import { Button, Drawer, Space } from "antd";
import { AiOutlineClose } from "react-icons/ai";

export default function UnitDetails({isVisible, setVisible, selected}: any) {
  return (
    <Drawer
      title={`APPROVAL METRIX`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}  
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
        </Drawer>
  )
}
